module.exports = __webpack_public_path__ + "img/resource-tech-image-24.a03a08c2.jpg";